export default __webpack_public_path__ + "static/QA-elaboracao-do-roteiro-macro-d5896c36cb92a880f66d03694791bdd6.png";